import React, { useState } from 'react';
import './Home.css';

function Home() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="home">
      {/* Hero Area */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-left">
            {/* <p className="social-proof">1200+ active users</p> */}
            <h1 className="hero-title">Never Miss a Deal Again</h1>
            <p className="hero-subtitle">
              Track prices across your favorite retailers and get instant alerts when prices drop. 
              Save time and money with automated price monitoring.
            </p>
            <div className="hero-ctas">
              <button 
                className="cta-button primary"
                onClick={() => window.location.href = '/signin'}
              >
                Start Tracking Products
              </button>
            </div>
          </div>
          <div className="hero-right">
            <div className="hero-image-placeholder">
              <p>Product Screenshot</p>
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="partners">
        <div className="container">
          <p className="partners-text">Track prices from major retailers:</p>
          <div className="partners-logos">
            {[
              'abercrombie',
              'arcteryx',
              'asos',
              'gymshark',
              'hollister',
              'lululemon',
              'mango',
              'nike',
              'patagonia',
              'uniqlo',
              'zara'
            ].map((retailer) => (
              <img
                key={retailer}
                src={`/static/retailers/${retailer}.png`}
                alt={retailer}
                className="retailer-logo"
              />
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits">
        <div className="container">
          <h2 className="section-title">Benefits</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">💰</div>
              <h3>Save Money</h3>
              <p>Get notified the moment prices drop, never miss a deal again</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">⏰</div>
              <h3>Save Time</h3>
              <p>No more manually checking prices. We monitor 24/7 so you don't have to</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">🔔</div>
              <h3>Instant Alerts</h3>
              <p>Receive email notifications the moment your target price is reached</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">🛍️</div>
              <h3>Multiple Stores</h3>
              <p>Track products from dozens of retailers all in one place. Close all those tabs!</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How it works?</h2>
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">1</div>
              <h3>Add Product URL</h3>
              <p>Simply paste the product URL from any supported retailer</p>
            </div>
            <div className="step-card">
              <div className="step-number">2</div>
              <h3>Set Alert Price</h3>
              <p>Enter your target price and we'll monitor it for you</p>
            </div>
            <div className="step-card">
              <div className="step-number">3</div>
              <h3>Get Notified</h3>
              <p>Receive an email when the price drops to your target</p>
            </div>
          </div>
        </div>
      </section>

      {/* Advertising Section */}
      <section className="pricing">
        <div className="container">
          <h2 className="section-title">Advertise With Us</h2>
          <div className="pricing-grid">
            <div className="pricing-card">
              <h3>Reach Engaged Shoppers</h3>
              <p style={{ textAlign: 'center', marginBottom: '2rem', opacity: 0.8 }}>
                Connect with users actively tracking prices and ready to make purchases
              </p>
              <button className="pricing-cta" onClick={() => window.location.href = '/signin'}>
                Learn More
              </button>
            </div>
            <div className="pricing-card featured">
              <div className="popular-badge">Most Popular</div>
              <h3>Premium Placement</h3>
              <p style={{ textAlign: 'center', marginBottom: '2rem', opacity: 0.8 }}>
                Get your products featured prominently to maximize visibility and conversions
              </p>
              <button className="pricing-cta" onClick={() => window.location.href = '/signin'}>
                Contact Us
              </button>
            </div>
            <div className="pricing-card">
              <h3>Targeted Campaigns</h3>
              <p style={{ textAlign: 'center', marginBottom: '2rem', opacity: 0.8 }}>
                Reach the right audience with our advanced targeting and analytics tools
              </p>
              <button className="pricing-cta" onClick={() => window.location.href = '/signin'}>
                Get Started
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      {/* <section className="testimonials">
        <div className="container">
          <h2 className="section-title">Loved by people worldwide</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-avatar"></div>
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">
                "Cart Scanners saved me over $200 last month! I set alerts for items I wanted 
                and got notified the moment they went on sale."
              </p>
              <p className="testimonial-author">- Sarah M.</p>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-avatar"></div>
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">
                "Finally, a tool that actually works! No more checking prices manually. 
                The alerts are instant and accurate."
              </p>
              <p className="testimonial-author">- John D.</p>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-avatar"></div>
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">
                "I track products from 10+ stores. This tool makes it so easy to manage 
                everything in one place."
              </p>
              <p className="testimonial-author">- Emily R.</p>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-avatar"></div>
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">
                "The price history feature helped me time my purchase perfectly. 
                Highly recommend!"
              </p>
              <p className="testimonial-author">- Mike T.</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* FAQ Section */}
      <section className="faq">
        <div className="container">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <div className="faq-list">
            {[
              { q: "How often are prices checked?", a: "Prices are checked daily and alerts are sent as soon as a drop is detected." },
              { q: "Which retailers are supported?", a: "The retailers we support are listed above near the top of the home page. This list is growing every day and you can suggest retailers here." },
              { q: "Will more retailers be added?", a: "Yes. We aim to increase the number of stores we support every week and we do this in order of popularity so please make a request here. Eventually we aim to support all retailers." },
              { q: "Why do wait times differ when fetching prices from different retailers?", a: "Different prices have to be accessed in different ways. Sometimes this takes time (up to 2 minutes on some sites). However, you only have to save it once and then it is tracked forever so it is time well spent we think!" },
              
            ].map((faq, index) => (
              <div key={index} className="faq-item">
                <button 
                  className="faq-question" 
                  onClick={() => toggleFaq(index)}
                >
                  {faq.q}
                  <span className="faq-arrow">{openFaq === index ? '▲' : '▼'}</span>
                </button>
                {openFaq === index && (
                  <div className="faq-answer">{faq.a}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">Ready to start saving?</h2>
          <p className="cta-subtitle">Never miss a deal again</p>
          <button 
            className="cta-button large"
            onClick={() => window.location.href = '/signin'}
          >
            Get Started Free
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <img 
                src="/static/logo.png" 
                alt="Cart Scanners" 
                className="footer-logo"
                onError={(e) => {
                  console.error('Footer logo failed to load from:', e.target.src);
                  e.target.style.display = 'none';
                }}
              />
              <p>Track prices. Save money. Never miss a deal.</p>
            </div>
            <div className="footer-links">
              <div className="footer-column">
                <h4>Menu</h4>
                <a href="/">Home</a>
                <a href="/products">Products</a>
                <a href="/signin">Sign In</a>
              </div>
              <div className="footer-column">
                <h4>Legal</h4>
                <a href="/privacy">Privacy Policy</a>
                <a href="/terms">Terms of Service</a>
                <a href="/cookies">Cookie Policy</a>
              </div>
              <div className="footer-column">
                <h4>Newsletter</h4>
                <p>Stay updated with tips and deals</p>
                <div className="newsletter-form">
                  <input type="email" placeholder="Enter your email" />
                  <button>Subscribe</button>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Cart Scanners. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;

